import {
  useDeleteProtocolMutation,
  useLazyDownloadProtocolQuery,
  useLazyGetAllProtocolsQuery,
  useUpdateProtocolMutation,
  useUploadProtocolMutation,
} from "../store/services/protocolQuery";

export const useProtocol = () => {
  const [
    uploadProtocol,
    {
      data: uploadProtocolData,
      isLoading: uploadProtocolsLoading,
      isError: uploadProtocolIsError,
      error: uploadProtocolError,
      isSuccess: uploadProtocolIsSuccess,
    },
  ] = useUploadProtocolMutation();

  const [
    downloadProtocol,
    {
      data: downloadProtocolData,
      isLoading: downloadProtocolIsLoading,
      isError: downloadProtocolIsError,
      error: downloadProtocolError,
      isSuccess: downloadProtocolIsSuccess,
    },
  ] = useLazyDownloadProtocolQuery();

  const [
    getAllProtocols,
    {
      data: allProtocolsData,
      isLoading: allProtocolsIsLoading,
      isError: allProtocolsIsError,
      error: allProtocolsError,
      isSuccess: allProtocolsIsSuccess,
    },
  ] = useLazyGetAllProtocolsQuery();

  const [
    updateProtocol,
    {
      data: updateProtocolData,
      isLoading: updateProtocolsLoading,
      isError: updateProtocolIsError,
      error: updateProtocolError,
      isSuccess: updateProtocolIsSuccess,
    },
  ] = useUpdateProtocolMutation();

  const [
    deleteProtocol,
    {
      data: deleteProtocolData,
      isLoading: deleteProtocolsLoading,
      isError: deleteProtocolIsError,
      error: deleteProtocolError,
      isSuccess: deleteProtocolIsSuccess,
    },
  ] = useDeleteProtocolMutation();

  return {
    uploadProtocol,
    uploadProtocolData,
    uploadProtocolsLoading,
    uploadProtocolIsError,
    uploadProtocolError,
    uploadProtocolIsSuccess,
    downloadProtocol,
    downloadProtocolData,
    downloadProtocolIsLoading,
    downloadProtocolIsError,
    downloadProtocolError,
    downloadProtocolIsSuccess,
    getAllProtocols,
    allProtocolsData,
    allProtocolsIsLoading,
    allProtocolsIsError,
    allProtocolsError,
    allProtocolsIsSuccess,
    updateProtocol,
    updateProtocolData,
    updateProtocolsLoading,
    updateProtocolIsError,
    updateProtocolError,
    updateProtocolIsSuccess,
    deleteProtocol,
    deleteProtocolData,
    deleteProtocolsLoading,
    deleteProtocolIsError,
    deleteProtocolError,
    deleteProtocolIsSuccess,
  };
};
